module.exports = "/assets/data/9c12a377298bc768216432f33adeba1c-BB4.data.json";